// eslint-disable-next-line @typescript-eslint/no-unused-vars
export const customErrorResponse = (error: any) => {
  // For now just display the same error
  return `Something has gone wrong, please try again or contact an administrator`;
};
